import { createAction } from '@ngrx/store';

export const reduxReset = createAction('[App] Logout');
